import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import CancelSurgeryContainer from './components/CancelSurgeryContainer';
import NoUsageReasonsContainer from './components/NoUsageReasonsContainer';
import { setShowNoUsageToReportOrCancelPopup } from 'src/pages/reportUsage/redux/action/actionCreators';
import { unlockOrderFunc } from 'src/pages/reportUsage/redux/saga/dataServices';
import UnidPostPoneContainer from './components/UnidPostPoneContainer';
import CaseCancelOrUnidPostpone from './components/CaseCancelOrUnidPostpone';
import { logErrorToConsole } from 'src/utils/util';

const NoUsageToReportContainer = ({
    cancelSurgeryData,
    showNoUsageToReportPopup,
    showCancelSurgeryPopup,
    viewProcedureScreen,
    showUnidPostponePopup,
    showCaseCancelOrPostpone,
}) => {
    const dispatch = useDispatch();
    const loggedInUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    const cancelUsageInProgress = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageInProgress
    );
    const isFromOrderDetailsModal = useSelector(
        (state) => state.noUsageToReportReducer.isFromOrderDetailsModal
    );
    const noUsageToReportPopupRef = useRef();                                
    const cancelSurgeryPopupRef = useRef();
    const caseCancelOrPostponeRef = useRef();
    const unidPostponePopupRef = useRef();
    const backBtnClickHandler = (isFromNoUsageReasonsScreen) => {
        dispatch(
            setShowNoUsageToReportOrCancelPopup({
                showNoUsagePopup: false,
                showCancelPopup:
                    isFromNoUsageReasonsScreen &&
                    loggedInUserDetails?.uid !== cancelSurgeryData.createdBy,
                surgeryData:
                    isFromNoUsageReasonsScreen &&
                    loggedInUserDetails?.uid !== cancelSurgeryData.createdBy
                        ? cancelSurgeryData
                        : {},
                viewProcedureScreen: false,
                showCaseCancelOrPostpone: false,
            })
        );
        if (
            !(
                isFromNoUsageReasonsScreen &&
                loggedInUserDetails?.uid !== cancelSurgeryData.createdBy
            )
        ) {
            (cancelSurgeryData?.myCaseRef && cancelSurgeryData?.myCaseRef?.length > 0) && unlockOrderFunc({
                action: 'NoUsageToReport',
                myCaseRefId: cancelSurgeryData?.myCaseRef,
            });
        }
    };

    return (
        <div>
            {cancelSurgeryData &&
                Object.keys(cancelSurgeryData).length > 0 &&
                !viewProcedureScreen && (
                    <ModalDialog
                        modalHeight={
                            showCaseCancelOrPostpone ? '195px' :
                            showCancelSurgeryPopup || showCaseCancelOrPostpone
                                ? '247px'
                                : '375px'
                        }
                        modalWidth={
                            showCaseCancelOrPostpone ? 'max-content' :
                            showCancelSurgeryPopup || showCaseCancelOrPostpone
                                ? '469px !important'
                                : '644px !important'
                        }
                        smalModalWidth={showCaseCancelOrPostpone && 'max-content !important'}
                        zIndex={2000}
                        padding={showCaseCancelOrPostpone ? '4px 15px 15px' :
                            showCancelSurgeryPopup || showCaseCancelOrPostpone
                                ? '0 9px'
                                : '4px 20px 20px'
                        }
                        marginTop={'6.75rem'}
                        handleClose={() => {
                            try {
                            if(showNoUsageToReportPopup){ 
                                noUsageToReportPopupRef.current.redirectToCalendarOrOrdersPage();                               
                            } else if(showCancelSurgeryPopup){
                                cancelSurgeryPopupRef.current.redirectToCalendarOrOrdersPage();
                            } else if(showCaseCancelOrPostpone){
                                caseCancelOrPostponeRef.current.redirectToCalendarOrOrdersPage();
                            } else if(showUnidPostponePopup){
                                unidPostponePopupRef.current.redirectToCalendarOrOrdersPage();
                            }
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        {showNoUsageToReportPopup ? (
                            <NoUsageReasonsContainer
                                ref={noUsageToReportPopupRef}
                                cancelSurgeryData={cancelSurgeryData}
                                backBtnClickHandler={backBtnClickHandler}
                                isFromOrderDetailsModal={
                                    isFromOrderDetailsModal
                                }
                            />
                        ) : showCancelSurgeryPopup ? (
                            <CancelSurgeryContainer
                                ref={cancelSurgeryPopupRef}
                                cancelSurgeryData={cancelSurgeryData}
                                backBtnClickHandler={backBtnClickHandler}
                                isFromOrderDetailsModal={
                                    isFromOrderDetailsModal
                                }
                                showUnidPostponePopup={showUnidPostponePopup}
                            />
                        ) : showCaseCancelOrPostpone ? (
                            <CaseCancelOrUnidPostpone
                                ref={caseCancelOrPostponeRef}
                                cancelSurgeryData={cancelSurgeryData}
                                backBtnClickHandler={backBtnClickHandler}
                                // isFromOrderDetailsModal={
                                //     isFromOrderDetailsModal
                                // }
                                // showUnidPostponePopup={showUnidPostponePopup}
                            />
                        ) : (
                            showUnidPostponePopup && (
                                <UnidPostPoneContainer
                                    ref={unidPostponePopupRef}
                                    cancelSurgeryData={cancelSurgeryData}
                                    backBtnClickHandler={backBtnClickHandler}
                                    isFromOrderDetailsModal={
                                        isFromOrderDetailsModal
                                    }
                                />
                            )
                        )}
                    </ModalDialog>
                )}
            {cancelUsageInProgress && (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner id="reportUsage-noUsageToReport-backdrop-loadingSpinner" animation="border" variant="primary" small />
                </Backdrop>
            )}
        </div>
    );
};

export default NoUsageToReportContainer;
